export const NOTIFICATION_TRIGGERS = [
  "TICKET_ANSWERED",
  "TRACKER_CAPTURED",
  "REGRESSION_TEST_SUCCEEDED",
  "REGRESSION_TEST_FAILED",
  "BAD_CSAT_SUBMITTED",
  "HITL_APPROVAL_REQUESTED",
  "USAGE_THRESHOLD_REACHED",
  "DAILY_DIGEST",
] as const;

export type NotificationTriggerType = (typeof NOTIFICATION_TRIGGERS)[number];

export const TRIGGER_DEFINITIONS: Record<
  NotificationTriggerType,
  { title: string; description: string }
> = {
  TICKET_ANSWERED: {
    title: "Notify on ticket answer",
    description: "Get notified when a ticket receives an answer",
  },
  TRACKER_CAPTURED: {
    title: "Notify on tracker captured",
    description: "Get notified when a tracker captures an event",
  },
  REGRESSION_TEST_SUCCEEDED: {
    title: "Notify on regression test success",
    description: "Get notified when a regression test passes successfully",
  },
  REGRESSION_TEST_FAILED: {
    title: "Notify on regression test failure",
    description: "Get notified when a regression test fails",
  },
  BAD_CSAT_SUBMITTED: {
    title: "Notify on bad CSAT submitted",
    description: "Get notified when a bad CSAT is submitted",
  },
  HITL_APPROVAL_REQUESTED: {
    title: "Notify on HITL approval request",
    description: "Get notified when a human approval is required (HITL)",
  },
  USAGE_THRESHOLD_REACHED: {
    title: "Notify when usage near limit (e.g.80%)",
    description: "Get alerted when your usage close to monthly quota (e.g. 80%)",
  },
  DAILY_DIGEST: {
    title: "Get a daily notification of the tickets and conversations answered",
    description: "Get a daily notification of your daily activity (tickets and conversations answered) at 10:00 AM (your timezone)",
  },
};

export function isNotificationTriggerType(
  value: string
): value is NotificationTriggerType {
  return (NOTIFICATION_TRIGGERS as readonly string[]).includes(value);
}
